export const Container = ({ children }: { children: React.ReactNode }) => {
  return <div className="w-full mt-3">{children}</div>;
};
